<template>
  <div id="app">
		<div class="conent-us" id="">
		  <a href="#1">
		    <img src="./assets/images/backTo.png" alt="advimg" />
		  </a>
		  <a href="http://meidaojia-business.mikecrm.com/5W1LYQV">
		    <img src="./assets/images/concat-us.png" alt="advimg" />
		  </a>
		</div>
    <!-- <NavBar /> -->
    <!-- 首页1大图  id="1" 锚点 -->
    <div class="bg1" id="1">
      <div class="target-fix"></div>
      <Home />
    </div>
    <div class="bg3" id="4">
      <div class="target-fix"></div>
      <!-- 商业场景 -->
      <Pannel4 />
    </div>
    <!-- 核心技术 -->
    <div class="bg4" id="5">
      <div class="target-fix"></div>
      <Pannel5 />
    </div>
    <!-- 特殊实力 -->
    <div class="bg6" id="6">
      <div class="target-fix"></div>
      <Pannel6 />
    </div>
    <!-- 生态落地 -->
    <div class="" id="7">
      <div class="target-fix"></div>
      <Pannel7 />
    </div>
    <!-- 关于我们 -->
    <div class="" id="13">
      <div class="target-fix"></div>
      <Pannel13 />
    </div>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Home from "./pages/Home.vue";
import Pannel4 from "./pages/Pannel4.vue";
import Pannel5 from "./pages/Pannel5.vue";
import Pannel6 from "./pages/Pannel6.vue";
import Pannel7 from "./pages/Pannel7.vue";

import Pannel13 from "./pages/Pannel13.vue";
export default {
  name: "app",
  components: {
    NavBar,
    Home,
    Pannel4,
    Pannel5,
    Pannel6,
    Pannel7,
    Pannel13
  }
};
</script>

<style lang="less" scoped>
.target-fix {
  position: relative;
  display: block;
  height: 1px;
  overflow: hidden;
}
@media screen and (max-width: 767px) {

  // mobile
  .conent-us{
      width: 60px;
      height: 130px;
      // background: #001929;
      position: fixed;
      right: 0;
       bottom: 15%;
      z-index: 999999;
      img{
        width: 60px;
        height: 60px;
      }
    }
  .target-fix {
    top: -1rem; // 导航栏高度 6rem 和 pannel的margin-top 5rem
  }
}
@media screen and (min-width: 768px) {
  // tablet & pc
  .conent-us{
      width: 86px;
      height: 130px;
      // background: #001929;
      position: fixed;
      right: 0;
       bottom: 15%;
      z-index: 999999;
      img{
        width:86px;
        height: 86px;
      }
    }
  .target-fix {
    top: 15rem;
  }
}


</style>
